<template>
  <div class="templatedefault">
    <div class="slogan" :style="{color: homeslogancolor}" v-if="homeslogan">{{homeslogan}}</div>
    <div class="w-inner" flex="dir:left box:last" style="padding-top: 20px;margin:0 30px 30px 30px;">

      <div class="sidebar_a">
        <div class="main">
          <div v-for="(zbxxclass, index) in zbxxList" :key="" index>

            <div class="zbxxtitle">
              <div class="zbxxname">
                <div>{{zbxxclass.sys_dname}}
                  <span>{{zbxxclass.sys_engname}}</span>
                </div>
              </div>
              <div class="more" @click="toMore(zbxxclass)">更多 MORE<span>></span></div>
            </div>

            <div class="zbxxcontent">
              <div class="product" @click="toZbxxDetail(item)" v-for="item in zbxxclass.zbxx">
                <div class="jiantou"> ></div>
                <div class="p-value line-c" v-html="item.sys_title">
                </div>
                <div class="datecontent">{{item.sys_idate}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sidebar_b">

        <div class="left-content">
          <div class="btn-box">
            <div class="btn1" style="cursor: not-allowed;">
              <div class="btnleft"><i></i>专家入库<span>Expert</span></div>
              <div class="btnright">
                <div>---</div>
                <div>>>></div>
              </div>
            </div>
            <div class="btn2" @click="toOutLink(2)">
              <div class="btnleft"><i></i>投标人注册<span>Bidder</span></div>
              <div class="btnright">
                <div>---</div>
                <div>>>></div>
              </div>
            </div>
            <div class="btn3" @click="toOutLink(3)">
              <div class="btnleft"><i></i>招标人注册<span>Biddee</span></div>
              <div class="btnright">
                <div>---</div>
                <div>>>></div>
              </div>
            </div>
          </div>

          <div>

            <div class="left-title">
              <div class="title">
                <div class="label">{{sysparam.homesectitle6 ? sysparam.homesectitle6.sysparambeg : ''}}
                </div>
                <div class="little-title">{{sysparam.homesectitle6 ? sysparam.homesectitle6.sysparamend : ''}}</div>
              </div>
              <div class="more" @click="rigthToMore(sysparam.homesectitle6 ? sysparam.homesectitle6.sysparambeg : '')">
                更多<span>></span></div>
            </div>
            <div class="yjlist" >
              <div v-for="(item, index) in xzlist"  @click="downF(item)" :key="index">
                <div class="row">
                  <div class="point"></div>
                  <li>{{item.operwcontitle}}</li>
                </div>
              </div>
            </div>
          </div>
          <div>

            <div class="left-title">
              <div class="title">
                <div class="label">{{sysparam.homesectitle2 ? sysparam.homesectitle2.sysparambeg : ''}}
                </div>
                <div class="little-title">{{sysparam.homesectitle2 ? sysparam.homesectitle2.sysparamend : ''}}</div>
              </div>
              <div class="more" @click="rigthToMore(sysparam.homesectitle2 ? sysparam.homesectitle2.sysparambeg : '')">
                更多<span>></span></div>
            </div>
            <div class="news">
              <div flex="dir:left box:first" @click="Link(item)" class="wraper b-d-b" v-for="item  in list">
                <div style="width: 73px;
          height: 75px;cursor: pointer; background-color: #F6F6F6;margin-right: 10px;">
                  <div class="a-c" style="font-size: 30px;color: #f69806;">{{item.createtime | shortDate2}}</div>
                  <span class="a-c" style="color: #020202;">{{item.createtime | shortDate}}</span>
                </div>
                <div>
                  <h4 style="padding-top: 5px;cursor: pointer;display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;">{{item.operwcontitle | filter2}}</h4>
                  <p class="f_12" style="display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;line-height: 18px;color: #666;padding-top: 5px;cursor: pointer">
                    {{item.operwcondesc | filter}}</p>
                </div>
              </div>

            </div>
          </div>
          <div class="left-title">
            <div class="title">
              <div class="label">{{sysparam.homesectitle4 ? sysparam.homesectitle4.sysparambeg : ''}}</div>
              <div class="little-title">{{sysparam.homesectitle4 ? sysparam.homesectitle4.sysparamend : ''}}</div>
            </div>
            <div class="more" @click="rigthToMore(sysparam.homesectitle4 ? sysparam.homesectitle4.sysparambeg : '')">
              更多<span>></span></div>
          </div>
          <div class="contactus">
            <div>地址：{{sysparam.address ? sysparam.address.sysparambeg : ''}}</div>
            <div>热线：{{sysparam.hottel ? sysparam.hottel.sysparambeg : ''}}</div>
            <div>总机：{{sysparam.generalnumber ? sysparam.generalnumber.sysparambeg : ''}}</div>
            <div>传真：{{sysparam.fax ? sysparam.fax.sysparambeg : ''}}</div>
            <div>邮箱：{{sysparam.email ? sysparam.email.sysparambeg : ''}}</div>
          </div>
          <div class="left-title">
            <div class="title">
              <div class="label">{{sysparam.homesectitle5 ? sysparam.homesectitle5.sysparambeg : ''}}</div>
              <div class="little-title">{{sysparam.homesectitle5 ? sysparam.homesectitle5.sysparamend : ''}}</div>
            </div>
            <div class="more" @click="rigthToMore(sysparam.homesectitle5 ? sysparam.homesectitle5.sysparambeg : '')">
              更多<span>></span></div>
          </div>
          <div class="yjlist">
            <div v-for="(item, index) in yjlist" @click="Link(item)" :key="index">
              <div class="row">
                <div class="point"></div>
                <li>{{item.operwcontitle}}</li>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import utils from '../../assets/js/utils.js'
  import dayjs from 'dayjs'
  import common from '../../mixin/common'
  export default {
    mixins: [common],
    data () {
      return {
        list: [],
        yjlist: [],
        xzlist: [],
        homeWconList: [],
        zbxxclassList: [],
        zbxxList: [],
        swiperList: [],
        mtList: [],
        homeslogan: '',
        homeslogancolor: '',
        ww: window
      }
    },
    created () {
      this.$store.dispatch('getSysparam').then(data => {
        this.homeslogan = data.homeslogan ? data.homeslogan.sysparambeg : ''
        this.homeslogancolor = data.homeslogancolor ? data.homeslogancolor.sysparambeg : ''
        this.getWconId()
        this.getYeJiData()
        this.getXiaJiaData()
        this.getZbxxList()
        this.getOperMtId()
      })
    },
    methods: {
      downF (item) {
        if (item.appends) {
          this.downFile(item.appends.appendurl)
        }
      },
      toOutLink (type) {
        if (type === 1) {
          this.ww.open('https://www.eebidding.com/f/sys/reg/expertForm', '_blank')
        } else if (type === 2) {
          this.ww.open('https://www.eebidding.com/f/sys/reg/bidderForm', '_blank')
        } else if (type === 3) {
          this.ww.open('https://www.eebidding.com/f/sys/reg/tendererForm', '_blank')
        }
      },
      getOperMtId () {
        this.$store.dispatch('findOperMtId').then(list => {
          this.mtList = list
        })
      },
      toMore (row) {
        // 新页面打开
        // let {href} = this.$router.resolve({name: 'zbxx', query: {type: row.id}})
        // window.open(href, '_blank')

        // 当前页面打开
        this.$router.push({name: 'zbxx', query: {type: row.id}})
      },
      toZbxxDetail (row) {
        let {href} = this.$router.resolve({name: 'zbxxDetail', query: {id: row.id}})
        window.open(href, '_blank')
      },
      Link (item) {
        this.$store.commit('setFirstActiveTab', item.operMt.parent.opermtid)
        this.$store.commit('setSecondActiveTab', item.operMt.opermtid)
        this.$store.commit('changId', item.operwconmtid)
        this.$router.push({name: 'operWconDetail', query: {id: item.operwconid, mtid: item.operMt.opermtparentid}})
      },
      // 招标信息
      getZbxxList () {
        this.$store.dispatch('getZbxxList', {
          limit: 7,
          offset: 0
        }).then(data => {
          this.zbxxList = data
          this.zbxxList = this.zbxxList.map(v => {
            v.sys_idate = dayjs(v.sys_idate).format('YYYY-MM-DD')
            v.kbdate = dayjs(v.kbdate).format('YYYY-MM-DD')
            return v
          })
        })
      },
      // 最新新闻
      getWconId () {
        if (this.sysparam.homesectitle2 && this.sysparam.homesectitle2.sysparambeg) {
          this.$store.dispatch('getIndexWconList', {
            opermtname: this.sysparam.homesectitle2.sysparambeg,
            limit: 4,
            offset: 0
          }).then(data => {
            this.list = data
          })
        }
      },
      // 文件下载
      getXiaJiaData () {
        if (this.sysparam.homesectitle6 && this.sysparam.homesectitle6.sysparambeg) {
          this.$store.dispatch('getIndexWconList', {
            opermtname: this.sysparam.homesectitle6.sysparambeg,
            limit: 3,
            offset: 0
          }).then(data => {
            this.xzlist = data
          })
        }
      },
      // 业绩介绍
      getYeJiData () {
        if (this.sysparam.homesectitle5 && this.sysparam.homesectitle5.sysparambeg) {
          this.$store.dispatch('getIndexWconList', {
            opermtname: this.sysparam.homesectitle5.sysparambeg,
            limit: 4,
            offset: 0
          }).then(data => {
            this.yjlist = data
          })
        }
      },
      rigthToMore (opername) {
        this.$store.dispatch('findOperMtName', {
          opermtname: opername
        }).then(data => {
          let mt = data
          console.log(mt)
          this.$store.commit('changId', '')
          this.$store.commit('setFirstActiveTab', mt.opermtparentid)
          window.localStorage.setItem('firstActiveTab', mt.opermtparentid)
          this.$store.commit('setSecondActiveTab', mt.opermtid)
          this.$router.push({name: 'product', params: {operMtId: mt.opermtparentid}})
        })
      }
    },
    filters: {
      shortDate: function (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd').substring(0, 7)
      },
      shortDate2: function (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd').substring(8, 10)
      },
      filter: function (val) {
        return val.length > 35 ? val.substring(0, 35) + '...' : val.substring(0, 35)
      },
      filter2: function (val) {
        return val.length > 18 ? val.substring(0, 18) + '...' : val.substring(0, 18)
      }
    },
    components: {},
    computed: {
      ...mapState({
        sysparam: state => state.sysparam,
        picAddr: state => state.picAddr
      }),
      ...mapGetters({})
    }
  }
</script>

<style lang="stylus" scoped>
  .templatedefault
    display flex
    justify-content center
    /*background-color #9d2179*/
    color #333
    /*padding-bottom 25px*/
    font-family 'Helvetica Neue LT W05_75 Bold', 'Helvetica Neue World 75 Bold', Helvetica, Arial, sans-serif
    .slogan
      padding 50px 0
      font-size 30px
      font-weight 400
      line-height 40px
      color #004a96

    .sidebar_a
      flex: 1;
      overflow:hidden
      /*width: 922px;*/
      /*display flex*/
      .main
        display flex;
        flex-direction column;
        .zbxxtitle
          display flex
          align-items center
          border-bottom: 1px solid #f6f6f6;
          margin-bottom: 20px;
          /*margin-bottom: 22px;*/
          padding-right 10px
          border-left: 6px solid #4B71CD;
          /*padding-top 20px*/
          .zbxxname
            padding-left 10px
            font-weight: bold;
            /*padding-top: 5px;*/
            /*padding-bottom: 5px;*/
            font-size: 18px;
            flex 1
            span
              color: #b4b4b4;
              font-size: 12px;
          .more
            font-size: 14px;
            cursor pointer
            span
              color #E2E2E2
        .zbxxcontent
          padding-bottom 35px
          .product
            font-size 14px
            display flex
            justify-content center
            align-items center
            cursor pointer
            overflow:hidden
            /*background: #f6f6f6;*/
            margin-bottom: 5px;
            .jiantou
              color #004a96
              font-weight bold
              padding-left 10px
            .line-c
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            .p-value
              padding-left: 15px;
              padding-right: 30px;
              line-height: 28px;
              flex 1;
            .datecontent
              padding-right 10px
              color #A59999
          div:hover {
            cursor: pointer;
            color: #2074d0;
          }
    .sidebar_b {
      .left-content {
        margin-left: 25px;
        /*width: 360px;*/
        .btn-box {
          padding-bottom 30px
          /*text-align center*/
          font-size 18px
          font-weight bold
          .btn1 {
            display flex
            align-items center
            border-radius 5px;
            margin-bottom 10px
            padding 10px 20px
            background-color: #FFC000
            cursor pointer
            .btnleft {
              flex 1
              display flex
              align-items center
              span {
                color #FFFFFF
                font-size 14px
              }
              i {
                display: block;
                margin-right: 15px;
                width: 21px;
                height: 21px;
                background-size: 21px 21px;
                background-image: url("../../assets/images/ruku.png");
              }
            }
            .btnright {
              display flex
              align-items center
              color #FFFFFF
              font-size 16px
              font-weight normal
            }
          }
          .btn2 {
            display flex
            align-items center
            border-radius 5px;
            margin-bottom 10px
            padding 10px 20px
            background-color: #93CDDD
            cursor pointer
            .btnleft {
              flex 1
              display flex
              align-items center
              span {
                color #FFFFFF
                font-size 14px
              }
              i {
                display: block;
                margin-right: 15px;
                width: 21px;
                height: 21px;
                background-size: 21px 21px;
                background-image: url("../../assets/images/zhuce.png");
              }
            }
            .btnright {
              display flex
              align-items center
              color #FFFFFF
              font-size 16px
              font-weight normal
            }
          }
          .btn3 {
            border-radius 5px;
            background-color: #B3A2C7
            padding 10px 20px
            cursor pointer
            display flex
            align-items center
            .btnleft {
              flex 1
              display flex
              align-items center
              span {
                color #FFFFFF
                font-size 14px
              }
              i {
                display: block;
                margin-right: 15px;
                width: 21px;
                height: 21px;
                background-size: 21px 21px;
                background-image: url("../../assets/images/dengji.png");
              }
            }
            .btnright {
              display flex
              align-items center
              color #FFFFFF
              font-size 16px
              font-weight normal
            }
          }
        }
        .left-title {
          border-bottom: 1px solid #f6f6f6;
          margin-bottom: 20px;
          font-weight bold
          font-size: 18px;
          display flex
          align-items center
          .title {
            flex 1
            display flex
            align-items center
            .label {
              width: 80px;
              border-bottom: 1px solid #014283;
              padding-top: 5px;
              /*padding-bottom: 5px;*/
            }
            .little-title {
              color: #b4b4b4;
              font-size: 12px;
            }
          }
          .more {
            cursor pointer;
            font-weight normal
            font-size 14px
            span {
              color #E2E2E2;
            }
          }
        }
        .news {
          padding-bottom 20px
        }
        .contactus {
          padding-bottom 20px
          line-height 28px
          .addr {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .yjlist {
          display flex
          flex-direction column
          align-items flex-start
          line-height 30px;
          padding-bottom 20px
          .row {
            display: flex;
            align-items: center;
            .point {
              width: 2px;
              height: 2px;
              border-radius: 50%;
              border: 2px solid #2fa4e7;
              margin-right: 5px;
            }
            li {
              list-style: none;
              font-size: 14px;
              /*color: #818181;*/
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            li:hover {
              cursor: pointer;
              color: #2fa4e7;
            }
            .active {
              color: #2fa4e7;
            }
          }
        }

      }
    }
    span {
      padding: 0 5px 0 10px;
    }

    h3 {
      font-size: 18px;
      color: #252221;
    }

    h4 {
      font-size: 14px;
    }

    .wraper {
      height: 102px;
      padding-top: 13px;
    }

    div.wraper:first-child {
      padding-top: 0;
      height: 88px;
    }
</style>



// WEBPACK FOOTER //
// templateA.vue?6460ece2